import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    errors: {
      type: [Object, Array],
      description: 'allows object or array, beacuse of graphene formatting',
    },
  },
})
export default class BbFormComponent extends Vue {
  isSubmitted = false;

  mounted() {
    this.onFormSubmitted = this.onFormSubmitted.bind(this);
    this.$el.noValidate = true;
    this.$el.addEventListener('submit', this.onFormSubmitted);
  }

  onFormSubmitted(event) {
    event.preventDefault();
    this.isSubmitted = true;
    this.getFields().forEach((ctrl) => {
      ctrl.formSubmitted();
    });
    if (!this.$el.checkValidity || this.$el.checkValidity()) {
      this.$emit('submit', event);
    } else {
      this.focusErrorField();
    }
  }

  /**
   * Django default errors formatting is a dict with something like:
   * {
   *    field_name: ['error1', 'error2', ...],
   *    field_name2: ['error1', 'error2', ...],
   * }
   *
   *
   * But graphene sometimes may format then as array, like:
   * [
   *    {
   *      field: 'field_name',
   *      messages: ['error1', 'error2', ...],
   *    },
   *    {
   *      field: 'field_name2',
   *      messages: ['error1', 'error2', ...],
   *    },
   * ]
   *
   * this function will format always as the first aproach (dict).
   *
   */
  get errorsFormated() {
    if (this.errors instanceof Array) {
      return Object.assign(...this.errors.map(error => ({ [error.field]: error.messages })));
    }
    return this.errors;
  }

  @Watch('errors')
  onErrorsChanged() {
    this.getFields().forEach((ctrl) => {
      ctrl.setFormErrors(this.errorsFormated);
    });
    this.focusErrorField();
  }

  getFields() {
    return Array.from((
      this.$el.querySelectorAll('.BbField')
    )).map(e => e.bbFieldCtrl);
  }

  focusErrorField() {
    this.getFields().some((ctrl) => {
      const { isValid } = ctrl;
      if (!isValid) {
        ctrl.focus();
      }
      return !isValid;
    });
  }
}
